
import { createAsyncThunk } from '@reduxjs/toolkit'
import { RootThunkApi } from '../../../../app/store'
import { sendAsync } from '../../../../app/applicationSlice'
import { geRegistrationConfigList, getRegistrationConfigSubmit, getRegistrationConfigDetail } from '../../../../services/RegistrationFeeSetting'


export const getRegistrationConfigSubmitAsync = createAsyncThunk<void, any, RootThunkApi>(
  'dataPermision/getRegistrationConfigSubmit',
  async (body, api) => {
    return sendAsync(getRegistrationConfigSubmit(body), api)
  }
)

export const geRegistrationConfigListAsync = createAsyncThunk<
  any,
  any,
  RootThunkApi
>('dataPermision/geRegistrationConfigListAsync', async (params, api) => {
  return sendAsync(geRegistrationConfigList(params), api)
})

export const geRegistrationConfigDetailAsync = createAsyncThunk<
  any,
  void,
  RootThunkApi
>('dataPermision/geRegistrationConfigDetailAsync', async (_, api) => {
  return sendAsync(getRegistrationConfigDetail(), api)
})
